import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface ClassModuleListTemplateProps {
  /** Subtítulo (ex.: contagem de módulos). */
  readonly subtitle: string;
  /** Ações do cabeçalho (ex.: botão "Novo módulo"). */
  readonly headerActions: ReactNode;
  /** Card de filtros. */
  readonly filterPanel: ReactNode;
  /** Tabela de módulos. */
  readonly table: ReactNode;
}

/**
 * Layout da tela de listagem de módulos: breadcrumb, título + subtítulo, ações do
 * cabeçalho, card de filtros e card de tabela. Sem dados/lógica — recebe tudo por slots.
 */
export function ClassModuleListTemplate({
  subtitle,
  headerActions,
  filterPanel,
  table,
}: ClassModuleListTemplateProps) {
  const { t } = useTranslation('classModuleManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{t('breadcrumb.list')}</BreadcrumbPage>
      </Breadcrumb>

      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-nano">
          <h1 className="ts-heading-lg text-ctx-content-title">{t('list.title')}</h1>
          <p className="ts-paragraph-xs text-ctx-content-title">{subtitle}</p>
        </div>
        {headerActions}
      </div>

      <div className="my-xxs rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1">
        {filterPanel}
      </div>

      <div className="overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1">
        {table}
      </div>
    </div>
  );
}
